var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "report-card" }, [
    _c("div", { staticClass: "report-card__top" }, [
      _c("div", {
        staticClass: "report-card__title",
        domProps: { innerHTML: _vm._s(_vm.report.name) },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "report-card__actions" }, [
        _c(
          "div",
          {
            staticClass: "edit-card",
            on: {
              click: function ($event) {
                return _vm.viewItem(_vm.report.id)
              },
            },
          },
          [_vm._v("View")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "dell-card", on: { click: _vm.deleteItem } }, [
          _vm._v("Delete"),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }